import React from 'react';

const SvgIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="105" height="64" viewBox="0 0 300 181">
        <defs>
            <linearGradient id="a" x1="51.587%" x2="47.16%" y1="77.882%" y2="2.028%">
                <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
                <stop offset="100%" stopColor="#4CA6F7" stopOpacity=".3" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#2474DE"
                fillRule="nonzero"
                d="M263.887 165.958v1.6H68.735V164.9C27.378 165.895 0 167.647 0 169.576c0 3.075 67.147 5.558 150 5.558s150-2.52 150-5.558c0-1.387-13.639-2.647-36.113-3.618z"
                opacity=".1"
            />
            <circle cx="83.408" cy="34.122" r="34.122" fill="#FFE4CC" fillRule="nonzero" />
            <path
                fill="#C5D8B9"
                fillRule="nonzero"
                d="M35.357 166.903c0-10.285 6.958-20.974 13.298-20.974s9.643 10.689 9.643 20.974h-22.94z"
            />
            <path
                fill="#C5D8B9"
                fillRule="nonzero"
                d="M53.521 166.903c0-15.126 3.34-25.02 9.668-25.02 6.328 0 13.26 9.844 13.26 25.02H53.522z"
            />
            <path
                fill="#C5D8B9"
                fillRule="nonzero"
                d="M71.95 166.903c0-9.642 9.642-18.63 15.983-18.63 6.34 0 6.945 8.988 6.945 18.63H71.95z"
            />
            <path
                fill="url(#a)"
                fillRule="nonzero"
                d="M52.4 135.454C29.961 85.286 53.432.504 107.268 32.168 166.046 66.807 183.643-27.807 249.1 9.996c18.832 10.878 71.445 81.933 20.975 130.689-42.858 41.433-69.429-2.773-111.492-2.773-21.693 0-61.853 96.718-106.185-2.458z"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M209.496 164.017v-3.151"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="5.07"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M209.496 155.748v-54.97"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M209.496 98.218v-3.15M144.416 56.244v3.151"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="4.74"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M144.416 64.172v94.299"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M144.416 160.866v3.15M277.424 88.147l2.673 1.677h-3.152"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="5.01"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M271.89 89.824h-62.394L129.908 39.63"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M127.777 38.282l-2.66-1.677h3.152"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="5.01"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M133.31 36.605h62.396l79.588 50.193"
            />
            <path
                fill="#2474DE"
                fillRule="nonzero"
                d="M280.097 89.824h-70.601l-84.378-53.219h70.588z"
                opacity=".1"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="5"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M136.966 90.126l-85.222 12.97"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M263.546 95.067v3.151"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="5.36"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M263.546 103.626v58.11"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M263.546 164.433v3.151h-3.151"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="5.06"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M255.29 167.584H74.004"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M71.458 167.584h-3.151v-3.151"
            />
            <path
                stroke="#245ABC"
                strokeDasharray="5.36"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M68.307 159.038v-45.933"
            />
            <path
                stroke="#245ABC"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M68.307 110.408v-3.152"
            />
            <path
                fill="#2474DE"
                fillRule="nonzero"
                d="M156.164 131.332v36.315h19.903v-36.315zM83.231 123.454h20.748v21.378H83.231zM110.092 123.454h20.748v21.378h-20.748z"
                opacity=".1"
            />
            <path
                fill="#2474DE"
                fillRule="nonzero"
                d="M156.277 100.374h41.357v23.08h-41.357z"
                opacity=".06"
            />
            <path
                fill="#2474DE"
                fillRule="nonzero"
                d="M209.496 89.824v77.823h54.05V89.824h-54.05zm43.865 33.63h-33.617v-23.08h33.617v23.08z"
                opacity=".1"
            />
            <path
                fill="#C5D8B9"
                fillRule="nonzero"
                d="M282.996 169.613c0-10.752-7.26-21.907-13.866-21.907-6.605 0-10.084 11.155-10.084 21.907h23.95z"
            />
            <path
                fill="#C5D8B9"
                fillRule="nonzero"
                d="M264.038 169.613c0-15.857-3.48-26.13-10.084-26.13-6.605 0-13.866 10.273-13.866 26.13h23.95z"
            />
            <path
                fill="#C5D8B9"
                fillRule="nonzero"
                d="M244.803 169.613c0-10.084-10.085-19.462-16.69-19.462s-7.247 9.391-7.247 19.462h23.95-.013z"
            />
            <g fill="#2474DE" fillRule="nonzero" opacity=".04">
                <path d="M156.277 100.374h3.189v23.08h-3.189z" />
                <path d="M156.277 103.563v-3.19h41.357v3.19z" />
            </g>
            <g fill="#2474DE" fillRule="nonzero" opacity=".04">
                <path d="M110.156 123.454h3.189v21.378h-3.19z" />
                <path d="M110.155 126.643v-3.19h20.685v3.19z" />
            </g>
            <g fill="#2474DE" fillRule="nonzero" opacity=".04">
                <path d="M83.27 123.454h3.188v21.378H83.27z" />
                <path d="M83.269 126.643v-3.19h20.685v3.19z" />
            </g>
            <g fill="#2474DE" fillRule="nonzero" opacity=".15">
                <path d="M253.286 123.454h-3.19v-23.08h3.19z" />
                <path d="M219.744 103.576v-3.19h33.542v3.19z" />
            </g>
        </g>
    </svg>
);

export default SvgIcon;
